module.exports = __webpack_public_path__ + "static/simple-store-demo-a40940291160bca3b300d4246cea7e5c.png";